import React from 'react';


const BellIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff"><path d="M12 2c-.8 0-1.5.7-1.5 1.5v.69A6.93 6.93 0 0 0 5 11v4.5l-2 2.31V19h18v-1.19l-2-2.31V11a6.94 6.94 0 0 0-5.5-6.81V3.5c0-.8-.7-1.5-1.5-1.5zm-2 18a2 2 0 0 0 4 0z"></path></svg>
);

export default BellIcon;
